import type { RouteEntry } from "../catalog/route-definition.ts";
import type {
  Catalog,
  GameName,
  ResourceName,
  RouteName,
  RouteParams,
  StaticName,
} from "../routes.types.ts";

type MatchOwnership<Name extends RouteName> = {
  readonly bucket: Exclude<Catalog[Name]["bucket"], "catalog">;
  readonly entry: Catalog[Name]["entry"];
  readonly disposition: Catalog[Name]["disposition"];
};

type StaticArea<Name extends StaticName> =
  Catalog[Name]["bucket"] extends "admin"
    ? "admin"
    : Catalog[Name]["bucket"] extends "marketing"
      ? "marketing"
      : Catalog[Name]["bucket"] extends "docs"
        ? "docs"
        : Catalog[Name]["bucket"] extends "unlisted"
          ? "office"
          : "product";

type StaticMatch = {
  [Name in StaticName]: {
    readonly name: Name;
    readonly area: StaticArea<Name>;
    readonly section: null;
  } & Omit<RouteParams<Name>, "section"> &
    MatchOwnership<Name> &
    (Name extends "policy" ? { readonly version?: number } : object);
}[StaticName];

type GameMatch = {
  readonly area: "game";
  readonly section: string;
  readonly gameSlug: string;
  readonly league?: string;
  readonly catalogScope: "listed" | "unlisted";
  readonly bucket: "app" | "unlisted";
  readonly entry: RouteEntry;
};

type MatchedGameRoute = {
  [Name in GameName | ResourceName]: {
    readonly name: Name;
    readonly disposition: Catalog[Name]["disposition"];
  } & GameMatch &
    RouteParams<Name>;
}[GameName | ResourceName];

export const unknownRoute = {
  name: "unknown",
  area: "other",
  section: null,
  bucket: null,
  entry: null,
  disposition: "unknown",
} as const;

export type MatchedRoute = typeof unknownRoute | StaticMatch | MatchedGameRoute;
export type MatchCandidate = Readonly<Record<string, unknown>>;
